import { phaseLabel } from './task-phase-label';
import type { TaskPhase } from '../../api/v1';
import './TaskPhasesList.css';

/**
 * "Waypoints visited" record (plan §Phase 4E) — works the same way
 * for every category since delivery/clean phases are ALSO go-to-place
 * navigation under the hood: patrol shows every place visited in
 * order, delivery shows pickup(s)/dropoff(s), clean shows the
 * cleaning area, whichever the task's own phases resolved to.
 */


function statusSymbol(status: TaskPhase['status']): string {
  if (status === 'completed') return '✓';
  if (status === 'active') return '➜';
  if (status === 'skipped') return '⤳';
  return '○';
}

export function TaskPhasesList({
  phases,
  emptyText,
}: {
  phases: TaskPhase[] | undefined;
  /** What to say when there is nothing yet. A QUEUED task has visited
   *  nowhere, which is not the same as a task whose detail was never
   *  recorded, and the drawer now says so. */
  emptyText?: string;
}) {
  if (!phases || phases.length === 0) {
    return (
      <p className="nx-task-phases__empty">
        {emptyText ?? 'No waypoint detail recorded for this task.'}
      </p>
    );
  }
  return (
    <ol className="nx-task-phases" data-testid="task-phases-list">
      {phases.map((p) => (
        <li
          key={p.id}
          className={`nx-task-phases__item nx-task-phases__item--${p.status ?? 'pending'}`}
        >
          <span className="nx-task-phases__icon" aria-hidden="true">
            {statusSymbol(p.status)}
          </span>
          <span className="nx-task-phases__label">{phaseLabel(p)}</span>
        </li>
      ))}
    </ol>
  );
}
